import React from "react";
var __jsx = React.createElement;
import Accordion from "@componentsShared/Tailwind/Accordion/Accordion";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { trackEvents } from "@/common/events/events";
var PreCheckoutFAQs = function PreCheckoutFAQs() {
  var _useCheckoutOrder$sta;
  var faqs = (_useCheckoutOrder$sta = useCheckoutOrder().state.checkoutOrder) === null || _useCheckoutOrder$sta === void 0 ? void 0 : _useCheckoutOrder$sta.faqs;
  var data = (faqs === null || faqs === void 0 ? void 0 : faqs.questions) || [];
  if (!data.length) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-base text-center font-bold text-primary-new"
  }, faqs === null || faqs === void 0 ? void 0 : faqs.title), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text font-medium text-center text-xs"
  }, faqs === null || faqs === void 0 ? void 0 : faqs.subtitle)), /*#__PURE__*/React.createElement(Accordion, null, data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion.Item, {
      background: "bg-white",
      defaultOpen: index === 0,
      key: "accordion-".concat(index),
      className: "filter drop-shadow-[0_1px_4.4px_rgba(0,0,0,0.08)] rounded-lg border-none px-4 py-3"
    }, /*#__PURE__*/React.createElement(Accordion.Title, {
      className: "text-xs font-bold text-primary-new text-start p-0 cursor-pointer",
      iconContainerClassName: "ar:left-0 en:right-0",
      onClick: function onClick() {
        trackEvents("finance_faq_clicked", {
          question_number: index + 1
        });
      }
    }, item === null || item === void 0 ? void 0 : item.question), /*#__PURE__*/React.createElement(Accordion.Body, {
      className: "flex flex-col gap-3 p-0 pt-2 text-[#5E5E5E] text-xs font-normal leading-6"
    }, item === null || item === void 0 ? void 0 : item.answer));
  }))));
};
export default PreCheckoutFAQs;